import { datadogRum } from '@datadog/browser-rum'

import { actionTypes } from 'actions/actionTypes'
import tempActions from 'actions/temp'
import { trackSubscriptionCreated } from 'actions/tracking'
import { trackPurchase, trackSignupByPaymentMethod } from 'routes/Checkout/checkoutActions'
import {
  getCurrentPaymentMethod,
  isApplePayPayment,
  isGooglePayPayment,
  isPayPalExpressPayment,
} from 'routes/Checkout/checkoutPaymentSelectors'
import type { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'
import { getBasketRecipes, getPreviewOrderId } from 'selectors/basket'

import { getDeliveryAddress } from '../checkoutSelectors'

export const checkoutPostSignup: CheckoutActionCreator =
  ({ pricing }) =>
  async (dispatch, getState) => {
    dispatch(trackSubscriptionCreated({ pricing }))
    const state = getState()

    const orderId = getPreviewOrderId(state)
    const basketRecipes = getBasketRecipes(state)
    const town = getDeliveryAddress(state)?.get('town')

    dispatch({ type: actionTypes.CHECKOUT_SIGNUP_SUCCESS, orderId, basketRecipes, pricing, town }) // used for data layer tracking
    dispatch(tempActions.temp('originalGrossTotal', pricing.grossTotal))
    dispatch(tempActions.temp('originalNetTotal', pricing.netTotal))
    dispatch(trackPurchase({ orderId, pricing }))

    dispatch(trackSignupByPaymentMethod(getCurrentPaymentMethod(state)))

    datadogRum.addAction(`signup_successful`, {
      order: { id: orderId },
    })
    datadogRum.addAction(`signup_successful_${getCurrentPaymentMethod(state)}`, {
      order: { id: orderId },
    })

    // this triggers the reCAPTCHA execution in PayWithApplePay component or CheckoutPayment component
    // on success user will log in automatically
    if (
      isApplePayPayment(getState()) ||
      isGooglePayPayment(getState()) ||
      isPayPalExpressPayment(getState())
    ) {
      dispatch({
        type: actionTypes.EXPRESS_CHECKOUT_START_RECAPTCHA_EXECUTION,
        executionStarted: true,
      })
    } else {
      dispatch({
        // this is not always recaptcha related. This action type also determines
        // when to login after checkout is completed even when recapcha is off
        type: actionTypes.CHECKOUT_SIGNUP_START_RECAPTCHA_EXECUTION,
        executionStarted: true,
      })
    }
  }
